import request from '@/utils/request'

//商品评价列表
export function getCommentList(data) {
    return request({
        url: '/backend/ProductComment/getCommentList',
        method: 'post',
        data: data
    })
}

//修改评价状态
export function updateCommentStatus(data) {
    return request({
        url: '/backend/ProductComment/updateCommentStatus',
        method: 'post',
        data: data
    })
}